import { memo } from 'react';

import { type PublicClip } from '@air/api';
import { XIcon } from '@air/design-icons';
import { useAirModal } from '@air/provider-modal';
import { itemIsSelectedSelector } from '@air/redux-selected-items';

import { CardAction } from '~/components/CardAction';
import { ContentCollectionDeleteClipsModal } from '~/components/ContentCollection/ContentCollectionDeleteClipsModal';
import { selectedClipsSelector } from '~/store/selectedItems/selectors';
import { useAirStore } from '~/utils/ReduxUtils';

export type ContentCollectionGalleryAssetDeleteButtonProps = {
  clip: PublicClip;
};

export const ContentCollectionGalleryAssetDeleteButton = memo(
  ({ clip }: ContentCollectionGalleryAssetDeleteButtonProps) => {
    const store = useAirStore();
    const [showBoardCollectionDeleteClipsModal] = useAirModal(ContentCollectionDeleteClipsModal);

    return (
      <CardAction
        data-testid="CONTENT_COLLECTION_ASSET_DELETE_BUTTON"
        icon={<XIcon size="sm" />}
        // biome-ignore lint/performance/noJsxPropsBind: PLA-1724 — pre-existing debt, not introduced by the icon migration
        onClick={() => {
          const isSelected = itemIsSelectedSelector(store.getState(), clip.id);

          showBoardCollectionDeleteClipsModal({
            clips: isSelected ? selectedClipsSelector(store.getState()) : [clip],
          });
        }}
      />
    );
  },
);

ContentCollectionGalleryAssetDeleteButton.displayName = 'ContentCollectionGalleryAssetDeleteButton';
